// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterNavigation_root__U_hlP","link":"FooterNavigation_link__ytVUA"};